import { render } from "./AvfallOgGjenvinningMain.vue?vue&type=template&id=ed12ace6"
import script from "./AvfallOgGjenvinningMain.vue?vue&type=script&lang=js"
export * from "./AvfallOgGjenvinningMain.vue?vue&type=script&lang=js"

import "./AvfallOgGjenvinningMain.vue?vue&type=style&index=0&id=ed12ace6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__